export default __webpack_public_path__ + "static/montserrat-v14-latin-500-edd311588712a96bbf435fad264fff62.woff";